module.exports = __webpack_public_path__ + "static/media/logo-cc-blue.a70f9e88.svg";